type AuthLikeState = {
  user?: { id?: string } | null;
  business?: { id?: string; user_id?: string } | null;
};

/**
 * The `users.id` of the logged-in account.
 *
 * Student logins store the user record in `state.auth.user`; business logins
 * store the *business profile* in both `state.auth.user` and
 * `state.auth.business`, where `id` is the profile id and `user_id` is the
 * foreign key to `users`. Endpoints that take a `user_id` must therefore use
 * this helper instead of reading `user.id` directly.
 */
export const getAuthUserId = (auth: AuthLikeState | undefined | null): string =>
  auth?.business?.user_id || auth?.user?.id || "";
